import { useEffect, useState } from 'react';
import { Console, Hook, Unhook } from 'console-feed';

const sliders = [
  {
    key: 'degreeDistance',
    label: 'Degree Distance',
    min: 0,
    max: 300,
    step: 1,
  },
  {
    key: 'communityRepel',
    label: 'Community Repel',
    min: 0,
    max: 2,
    step: 0.05,
  },
  {
    key: 'mainAttract',
    label: 'Main Attract',
    min: 0,
    max: 2,
    step: 0.05,
  },
];

export default function DevConsole({ onClose, onReheat, showIds, setShowIds, physics, setPhysics }) {
  const [logs, setLogs] = useState([]);
  const [command, setCommand] = useState('');

  const helpText = {
    help: 'Show this message',
    reheat: 'Reheat the force simulation',
  };

  const commandHandlers = {
    reheat: () => {
      onReheat && onReheat();
    },
    help: () => {
      console.log('Available commands:');
      Object.entries(helpText).forEach(([name, desc]) => {
        console.log(` - ${name}: ${desc}`);
      });
    },
  };

  useEffect(() => {
    const hooked = Hook(window.console, (log) => setLogs((l) => [...l, log]), false);
    return () => Unhook(hooked);
  }, []);

  const handleCommand = (e) => {
    if (e.key === 'Enter') {
      const cmd = command.trim();
      const handler = commandHandlers[cmd];
      if (handler) {
        handler();
      } else {
        console.warn('Unknown command:', cmd);
      }
      setCommand('');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex flex-col">
      <div className="flex items-center justify-between p-2 bg-gray-800 text-white">
        <span>Console</span>
        <button
          type="button"
          className="text-sm border border-gray-500 rounded px-2 py-1"
          onClick={onClose}
        >
          Close
        </button>
      </div>
      <div className="flex-1 overflow-y-auto text-xs">
        <Console logs={logs} variant="dark" />
      </div>
      <div className="p-2 border-t border-gray-700 space-y-2">
        <label className="text-xs text-white flex items-center gap-1">
          <input
            type="checkbox"
            checked={showIds}
            onChange={(e) => setShowIds(e.target.checked)}
          />
          Show Node IDs
        </label>
        <div className="space-y-2 text-white text-xs">
          {sliders.map((s) => (
            <label key={s.key} className="block">
              <span className="mr-2">{s.label}</span>
              {physics[s.key]}
              <input
                type="range"
                className="w-full"
                min={s.min}
                max={s.max}
                step={s.step}
                value={physics[s.key]}
                onChange={(e) => setPhysics(s.key, parseFloat(e.target.value))}
              />
            </label>
          ))}
        </div>
        <input
          type="text"
          className="w-full bg-gray-900 text-white text-xs px-2 py-1 rounded"
          placeholder="Enter command..."
          value={command}
          onChange={(e) => setCommand(e.target.value)}
          onKeyDown={handleCommand}
        />
      </div>
    </div>
  );
}
